import { trackObject, usePromise, type PromiseState } from './usePromise.svelte';

export const useMutation = <Args extends Array<unknown>, Out>(
  promiseCreator: (...args: Args) => Promise<Out>,
  { clearAfterMs }: { clearAfterMs?: number } = {},
): { state: PromiseState<Out>; mutate: (...args: Args) => Promise<Out>; reset: () => void } => {
  let maybePromise = $state<null | Promise<Out>>(null);

  const promiseState = usePromise(() => maybePromise);

  return trackObject(() => ({
    state: promiseState,
    mutate: (...args: Args) => {
      const currentPromise = promiseCreator(...args);
      maybePromise = currentPromise;

      if (clearAfterMs === undefined) {
        return currentPromise;
      }
      return currentPromise.finally(() => {
        setTimeout(() => {
          if (maybePromise === currentPromise) {
            maybePromise = null;
          }
        }, clearAfterMs);
      });
    },
    reset: () => (maybePromise = null),
  }));
};
